import { createSlice } from '@reduxjs/toolkit';

import type { UsuarioState } from '@/types/usuario/usuarioTypes';

import {
  alterarSenha,
  listarCertificados,
  obterCertificadoAtivo,
  removerCertificado,
  salvarPreferenciasNotificacao,
  uploadCertificado,
} from './actions';

const initialState: UsuarioState = {
  isLoadingSenha: false,
  isLoadingCertificado: false,
  isLoadingPreferencias: false,
  errorSenha: null,
  errorCertificado: null,
  errorPreferencias: null,
  preferencias: null,
  certificadoAtivo: null,
  certificados: [],
};

const usuarioSlice = createSlice({
  name: 'usuario',
  initialState,
  reducers: {
    clearUsuarioErrors: (state) => {
      state.errorSenha = null;
      state.errorCertificado = null;
      state.errorPreferencias = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(alterarSenha.pending, (state) => {
        state.isLoadingSenha = true;
        state.errorSenha = null;
      })
      .addCase(alterarSenha.fulfilled, (state) => {
        state.isLoadingSenha = false;
      })
      .addCase(alterarSenha.rejected, (state, action) => {
        state.isLoadingSenha = false;
        state.errorSenha = action.payload as string;
      })

      .addCase(uploadCertificado.pending, (state) => {
        state.isLoadingCertificado = true;
        state.errorCertificado = null;
      })
      .addCase(uploadCertificado.fulfilled, (state, action) => {
        state.isLoadingCertificado = false;
        state.certificadoAtivo = action.payload;
      })
      .addCase(uploadCertificado.rejected, (state, action) => {
        state.isLoadingCertificado = false;
        state.errorCertificado = action.payload as string;
      })

      .addCase(obterCertificadoAtivo.pending, (state) => {
        state.isLoadingCertificado = true;
        state.errorCertificado = null;
      })
      .addCase(obterCertificadoAtivo.fulfilled, (state, action) => {
        state.isLoadingCertificado = false;
        state.certificadoAtivo = action.payload;
      })
      .addCase(obterCertificadoAtivo.rejected, (state, action) => {
        state.isLoadingCertificado = false;
        state.errorCertificado = action.payload as string;
      })

      .addCase(listarCertificados.pending, (state) => {
        state.isLoadingCertificado = true;
        state.errorCertificado = null;
      })
      .addCase(listarCertificados.fulfilled, (state, action) => {
        state.isLoadingCertificado = false;
        state.certificados = action.payload;
      })
      .addCase(listarCertificados.rejected, (state, action) => {
        state.isLoadingCertificado = false;
        state.errorCertificado = action.payload as string;
      })

      .addCase(removerCertificado.pending, (state) => {
        state.isLoadingCertificado = true;
        state.errorCertificado = null;
      })
      .addCase(removerCertificado.fulfilled, (state) => {
        state.isLoadingCertificado = false;
        state.certificadoAtivo = null;
      })
      .addCase(removerCertificado.rejected, (state, action) => {
        state.isLoadingCertificado = false;
        state.errorCertificado = action.payload as string;
      })

      .addCase(salvarPreferenciasNotificacao.pending, (state) => {
        state.isLoadingPreferencias = true;
        state.errorPreferencias = null;
      })
      .addCase(salvarPreferenciasNotificacao.fulfilled, (state, action) => {
        state.isLoadingPreferencias = false;
        const payload = action.payload as { preferencias?: UsuarioState['preferencias'] };
        if (payload && payload.preferencias) {
          state.preferencias = payload.preferencias;
        }
      })
      .addCase(salvarPreferenciasNotificacao.rejected, (state, action) => {
        state.isLoadingPreferencias = false;
        state.errorPreferencias = action.payload as string;
      });
  },
});

export default usuarioSlice.reducer;
